import {
  Box,
  Button,
  Collapse,
  IconButton,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Tooltip,
  Typography
} from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import React from 'react';
import { useSelector } from 'react-redux';

const StyledSectionTotalTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.blue.main,
    color: theme.palette.common.white,
    borderBottom: 'none'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    borderBottom: 'none'
  }
}));

const SectionTotalsCard = ({ section }) => {
  const event = useSelector((state) => state.event.event);
  const [expandedTeam, setExpandedTeam] = React.useState(null);

  const handleToggleTeam = (teamId) => {
    setExpandedTeam(expandedTeam === teamId ? null : teamId);
  };

  const getStatusNameAndColor = (status) => {
    switch (status) {
      case 2:
        return { name: 'In Progress', color: 'blue.main' };
      case 3:
        return { name: 'Completed', color: 'green.main' };
      case 1:
        return { name: 'Not Started', color: 'grey.800' };
      case 4:
        return { name: 'Playoff', color: 'orange.main' };
      default:
        return { name: 'Unknown', color: 'grey.800' };
    }
  };

  if (section.sectionTotals && section.sectionTotals.teams.length !== 0) {
    let teamSetTotals = section.sectionTotals.teams;
    const mutableTeamSetTotals = Array.from(teamSetTotals);

    teamSetTotals = mutableTeamSetTotals;

    return (
      <TableContainer
        key={section.id}
        component={Paper}
        sx={{
          borderRadius: 3,
          border: '1px solid',
          borderColor: 'blue.main'
        }}>
        <Table padding="none">
          <TableHead>
            <TableRow>
              <StyledSectionTotalTableCell padding="normal">#</StyledSectionTotalTableCell>
              <StyledSectionTotalTableCell padding="normal">
                <Typography variant="body1" fontWeight={'bold'}>
                  {section.sectionName}
                </Typography>
              </StyledSectionTotalTableCell>
              <StyledSectionTotalTableCell padding="normal" align={'center'}>
                <Tooltip title="Total Games Played">P</Tooltip>
              </StyledSectionTotalTableCell>
              <StyledSectionTotalTableCell padding="normal" align={'center'}>
                <Tooltip title="Total Games Won">W</Tooltip>
              </StyledSectionTotalTableCell>
              <StyledSectionTotalTableCell padding="normal" align={'center'}>
                <Tooltip title="Total Games Lost">L</Tooltip>
              </StyledSectionTotalTableCell>
              <StyledSectionTotalTableCell padding="normal" align={'center'}>
                <Tooltip title="Total Points">
                  <Typography variant="p" fontWeight={'bold'} color="white">
                    Pts
                  </Typography>
                </Tooltip>
              </StyledSectionTotalTableCell>
              {event.gameFormat.sets > 1 && (
                <StyledSectionTotalTableCell padding="normal" align={'center'}>
                  <Tooltip title="Total Sets Won">SW</Tooltip>
                </StyledSectionTotalTableCell>
              )}
              <StyledSectionTotalTableCell padding="normal" align={'center'}>
                <Tooltip title="Total Net Points">Net</Tooltip>
              </StyledSectionTotalTableCell>
              {/* <StyledSectionTotalTableCell padding="normal" align={'center'}>
                Rink
              </StyledSectionTotalTableCell>
              <StyledSectionTotalTableCell padding="normal" align={'center'}>
                Round
              </StyledSectionTotalTableCell>
              <StyledSectionTotalTableCell padding="normal" align={'center'}>
                Status
              </StyledSectionTotalTableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {teamSetTotals.map((team, index) => (
              <React.Fragment key={team.teamId}>
                <TableRow>
                  <StyledSectionTotalTableCell size="small" padding="normal">
                    {team.dnq ? (
                      <Typography variant="p" color="grey.800" fontWeight={'bold'}>
                        DNQ
                      </Typography>
                    ) : (
                      <Typography variant="p" color="blue.main" fontWeight={'bold'}>
                        {index + 1}
                      </Typography>
                    )}
                  </StyledSectionTotalTableCell>
                  <StyledSectionTotalTableCell size="small" padding="normal">
                    <Box display="flex" alignItems="center">
                      <IconButton
                        size="small"
                        onClick={() => handleToggleTeam(team.teamId)}
                        sx={{ mr: 1 }}>
                        {expandedTeam === team.teamId ? <ExpandLess /> : <ExpandMore />}
                      </IconButton>
                      <Typography
                        variant="p"
                        color={team.dnq ? 'grey.800' : 'inherit'}
                        sx={{ cursor: 'pointer' }}
                        onClick={() => handleToggleTeam(team.teamId)}>
                        {team.teamName}
                      </Typography>
                    </Box>
                  </StyledSectionTotalTableCell>
                  <StyledSectionTotalTableCell size="small" align={'center'}>
                    <Typography variant="p" color={team.dnq ? 'grey.800' : 'inherit'}>
                      {team.totalGames}
                    </Typography>
                  </StyledSectionTotalTableCell>
                  <StyledSectionTotalTableCell size="small" align={'center'}>
                    <Typography variant="p" color={team.dnq ? 'grey.800' : 'inherit'}>
                      {team.totalGamesWon}
                    </Typography>
                  </StyledSectionTotalTableCell>
                  <StyledSectionTotalTableCell size="small" align={'center'}>
                    <Typography variant="p" color={team.dnq ? 'grey.800' : 'inherit'}>
                      {team.totalGamesLost}
                    </Typography>
                  </StyledSectionTotalTableCell>
                  <StyledSectionTotalTableCell
                    size="small"
                    align={'center'}
                    sx={{ backgroundColor: 'blue.main' }}>
                    <Typography variant="p" fontWeight={'bold'} color="white">
                      {team.totalPoints}
                    </Typography>
                  </StyledSectionTotalTableCell>
                  {event.gameFormat.sets > 1 && (
                    <StyledSectionTotalTableCell size="small" align={'center'}>
                      <Typography color={team.dnq ? 'grey.800' : 'inherit'}>
                        {team.setsWon}
                      </Typography>
                    </StyledSectionTotalTableCell>
                  )}
                  <StyledSectionTotalTableCell size="small" align={'center'}>
                    <Typography variant="p" color={team.dnq ? 'grey.800' : 'inherit'}>
                      {team.totalNet}
                    </Typography>
                  </StyledSectionTotalTableCell>
                  {/* <StyledSectionTotalTableCell size="small" align={'center'}>
                    <Tooltip title="Green/Rink">
                      <Typography variant="p" color={team.dnq ? 'grey.800' : 'inherit'}>
                        {team.rink ? team.rink : 'N/A'}
                      </Typography>
                    </Tooltip>
                  </StyledSectionTotalTableCell>
                  <StyledSectionTotalTableCell size="small" align={'center'} padding="normal">
                    <Tooltip title="Current Round">
                      <Typography variant="p" color={team.dnq ? 'grey.800' : 'inherit'}>
                        {team.currentRound ? team.currentRound : 'N/A'}
                      </Typography>
                    </Tooltip>
                  </StyledSectionTotalTableCell>
                  {team.currentStatus && (
                    <StyledSectionTotalTableCell size="small" align={'center'} padding="normal">
                      <Tooltip title={getStatusNameAndColor(team.currentStatus).name}>
                        <Typography
                          variant="p"
                          color={getStatusNameAndColor(team.currentStatus).color}
                          fontWeight={'bold'}>
                          {getStatusNameAndColor(team.currentStatus).name}
                        </Typography>
                      </Tooltip>
                    </StyledSectionTotalTableCell>
                  )} */}
                </TableRow>

                {/* Collapsible row for team details */}
                <TableRow>
                  <StyledSectionTotalTableCell
                    colSpan={event.gameFormat.sets > 1 ? 11 : 10}
                    sx={{ padding: 0, border: 'none' }}>
                    <Collapse in={expandedTeam === team.teamId} timeout="auto" unmountOnExit>
                      <Box sx={{ p: 1 }}>
                        <Typography variant="caption" color="text.secondary">
                          {team.teamPlayers
                            .map((member) => `${member.name} ${member.surname}`)
                            .join(', ') || 'No team members found'}
                        </Typography>
                      </Box>
                    </Collapse>
                  </StyledSectionTotalTableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow key={'footer'} sx={{ backgroundColor: 'info.main' }} padding="none">
              <TableCell colSpan={'100%'} padding={'none'} align={'center'} sx={{ p: 1 }}>
                {section.sectionWinningTeam ? (
                  <Typography variant="caption" color={'white'} fontWeight={'bold'}>
                    Section won by {section.sectionWinningTeam.teamName}.{' '}
                    {section.winnerPlaysSection !== '' &&
                      'Plays ' + section.winnerPlaysSection + ' winner.'}
                  </Typography>
                ) : section.winnerPlaysSection !== '' ? (
                  <Typography variant="caption" color={'white'} fontWeight={'bold'}>
                    Section winner plays {section.winnerPlaysSection} winner.
                  </Typography>
                ) : null}
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    );
  } else {
    return (
      <TableContainer
        key={section.id}
        component={Paper}
        sx={{
          borderRadius: 3,
          maxWidth: 400,
          border: '1px solid',
          borderColor: 'blue.main'
        }}>
        <Table padding="none">
          <TableHead>
            <TableRow>
              <StyledSectionTotalTableCell padding="normal">
                <Typography variant="body1" fontWeight={'bold'}>
                  {section.sectionName}
                </Typography>
              </StyledSectionTotalTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <StyledSectionTotalTableCell size="small" padding="normal">
                No data available yet, check back again later.
              </StyledSectionTotalTableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
};

export default SectionTotalsCard;
